/* @jsx h */
import { h } from "preact";
import Button from "@ingka/button";
import PhonePayment from "@ingka/ssr-icon/paths/phone-payment";
import variables from "/src/scss/variables.module.scss";
import { useMediaQuery } from "react-responsive";
import { IKEA_FAMILY_REDIRECT_URL, MEDIA_QUERY_FOR_DESKTOP_VIEW } from "../../constants";
import { sendGAIkeaFamilyClick } from "../../helpers";
import "./cta.scss";

function CTA() {
    const { prefix: stylePrefix } = variables;
    // for resizing the button
    const isDesktop = useMediaQuery({ query: MEDIA_QUERY_FOR_DESKTOP_VIEW });

    const handleClick = () => {
        sendGAIkeaFamilyClick();
        window.location = IKEA_FAMILY_REDIRECT_URL;
    }

    return (
        <Button
            small={isDesktop}
            prefix={stylePrefix}
            text={`Sign In to Save Checklist to ${isDesktop ? "Phone" : "Computer"}`}
            iconPosition={"trailing"}
            ssrIcon={PhonePayment}
            type={"emphasised"}
            className={"cta-button"}
            onClick={handleClick}
        />
    );
}
export default CTA;
